export var argbToParts = function (hex) {
    if (!hex) {
        return hex;
    }
    var a = parseInt(hex.slice(1, 3), 16);
    var r = parseInt(hex.slice(3, 5), 16);
    var g = parseInt(hex.slice(5, 7), 16);
    var b = parseInt(hex.slice(7, 9), 16);
    return [r, g, b, a];
};
export var normalizeHex = function (hex) {
    if (!hex) {
        return hex;
    }
    var argbHex;
    if (hex.length === 7) {
        argbHex = "#ff".concat(hex.slice(1));
    }
    else if (hex.length === 9) {
        argbHex = hex;
    }
    else {
        console.warn("Invalid color hex: ".concat(hex));
        return '#FF000000';
    }
    return argbHex;
};
export var colorHexToRgbaCss = function (hex) {
    var argbHex = normalizeHex(hex);
    if (!hex) {
        return hex;
    }
    var _a = argbToParts(argbHex), r = _a[0], g = _a[1], b = _a[2], a = _a[3];
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(a / 255, ")");
};
export var argbHexColorToRGBColor = function (hex) {
    var argbHex = normalizeHex(hex);
    if (!argbHex) {
        return undefined;
    }
    var _a = argbToParts(argbHex), r = _a[0], g = _a[1], b = _a[2], a = _a[3];
    return { r: r, g: g, b: b, a: a / 255.0 };
};
